import React from 'react';
import '../../../styles/landing.css';
import '../../../styles/route.css';
import '../../../styles/how-it-works-driver.css';

const HowItWorksHero: React.FC = () => {
  return (
    <section className="driver-how-hero">
      <div className="container driver-how-hero-grid">
        <div className="driver-how-hero-copy">
          <span className="sw-eyebrow">How ShiftWagon works</span>
          <h1 className="driver-how-hero-title">Simple guides for every trip.</h1>
          <p className="driver-how-hero-sub">
            Learn how customers book deliveries and how drivers accept, move, and complete trips.
          </p>
          <div className="driver-how-hero-actions">
            <a className="sw-btn-primary" href="#guide-library-title">
              Choose a guide
            </a>
            <a className="sw-btn-secondary" href="/how-it-works/driver-app/instant-trips">
              Driver instant trips
            </a>
          </div>
        </div>

        <div className="driver-how-hero-visual" aria-label="ShiftWagon app previews">
          <div className="driver-how-preview-card driver-how-preview-card-user">
            <img
              src="/images/driver-how-to/user-app-home.jpeg"
              alt="User App home screen showing instant trips and scheduled trips"
            />
            <span>User App</span>
          </div>
          <div className="driver-how-preview-card driver-how-preview-card-driver">
            <img
              src="/images/driver-how-to/01-go-online.jpeg"
              alt="Driver App home screen showing online availability"
            />
            <span>Driver App</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksHero;
